// NATIVE


// INSTALLED
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';


// CUSTOM
import { Areas } from '../pages/area';
import { Cargos } from '../pages/cargos';
import { Main } from '../modules/main/Main';
import { LogAcciones } from '../pages/logAcciones';
import { Compania } from '../pages/company/Compania';
import { Sucursal } from '../pages/sucursal/Sucursal';
import { CrearEmpresa, DetalleCompania, EditarCompania } from '../pages/company';
import { CrearSucursalEmpresa, DetalleSucursal, EditarSucursal } from '../pages/sucursal';


// MANAGER 
import { Turnos } from '../pages/turnos';
import { Employees } from '../pages/talento-humano/employee';
import { CreateCustomer, Customer } from '../pages/manager/customers';
import { CreateEmployee } from '../pages/talento-humano/employee/CreateEmployee';
import { ControlTiempos } from '../pages/controlTiempos/ControlTiempos';
import { Parametros } from '../pages/parametros/Parametros';
import { Novedades } from '../pages/novedades/Novedades';
import { UsuariosPermisos } from '../pages/usuariosPermisos/UsuariosPermisos';
import { DetailCustomer } from '../pages/manager/customers/DetailCustomer';
import { EditCustomer } from '../pages/manager/customers/EditCustomer';
import { TipoNovedades } from '../pages/novedades/TipoNovedades';
import { NovedadesTurnos } from '../pages/novedades/NovedadesTurnos';
import { DetailEmployee } from '../pages/talento-humano/employee/DetailEmployee';
import { DetailUsuarioPermissions, EditUserPermissions } from '../pages/usuariosPermisos';
import { GenerarPorConfiguracion, TurnosEmpleados } from '../pages/turnosEmpleados';
// import { Terminals } from '../pages/terminals/terminal-control-tiempo-empleados/TerminalEmpleados';
import { CodigosExpressCheckin, RegistrosExpressCheckin } from '../pages/checkingExpress';
import { ReporteControlTiempos } from '../pages/reports';
import { TerminalDescansos } from '../pages/terminals/terminal-descansos';
import { EditEmployee } from '../pages/talento-humano/employee/EditEmployee';
import { CamposOrdenesServicio } from '../pages/ordenes-servicios/CamposOrdenesServicio';
import { AsignarCamposOrdenesServicio } from '../pages/ordenes-servicios/AsignarCamposOrdenesServicio';
import { OrdenesServicio } from '../pages/ordenes-servicios/OrdenesServicio';
import { CrearOrdenDeServicio } from '../pages/ordenes-servicios/CrearOrdenDeServicio';
import { Cotizaciones } from '../pages/ordenes-servicios/Cotizaciones';
import { CrearCotizacion } from '../pages/ordenes-servicios/CrearCotizacion';
import { TerminalEmpleados } from '../pages/terminals/terminal-control-tiempo-empleados';
import { GestionFinanciera, GestionFinancieraEmpleado } from '../pages/gestion-financiera';
import { GestionDispositivos } from '../pages/calificaciones/gestion-dispositivos';
import { ConfiguracionEncuestas } from '../pages/calificaciones/configuracion-encuestas';
import { AsignarEncuestas } from '../pages/calificaciones/asignar-encuestas';
import { GestionCalificaciones } from '../pages/calificaciones/gestion-calificaciones';
import { Perfil } from '../pages/perfil';
import { HallazgosAutomaticos } from '../pages/calificaciones/hallazgos-automaticos/HallazgosAutomaticos';
import { ReglasyAlertas } from '../pages/calificaciones/reglas-y-alertas/ReglasyAlertas';
import { Resumen } from '../pages/calificaciones/resumen';
import { Sla } from '../pages/calificaciones/sla';
import { AreasCalificaciones } from '../pages/calificaciones/areas';
import { Resumen as ResumenReputacion, Resenas, ReferidosComerciales, PlantillasRespuestas, Estadisticas } from '../pages/calificaciones/reputacion-online';
import { Configuracion } from '../pages/calificaciones/reputacion-online/configuracion';
import { LinksEncuestasPage } from '../pages/calificaciones/links-encuestas';
import { CreatePermissions, EditPermissions, Permissions, DetailPermissions } from 'pages/manager/permissions';
import { AjustesGlobalesIa, CreateAjustesGlobalesIa, DetailAjustesGlobalesIa, EditAjustesGlobalesIa } from 'pages/manager/servicios-ia/configuraion/ajustes-globales';
import { ServiciosIa, CreateServiciosIa, DetailServiciosIa, EditServiciosIa } from 'pages/manager/servicios-ia/configuraion/servicios';
import { SuscripcionesIa, CreateSuscripciones, DetailSuscripciones, EditSuscripciones } from 'pages/manager/servicios-ia/comercial/suscripciones';
import { BalanceIa, DetailBalanceIa } from 'pages/manager/servicios-ia/creditos/balance';
import { TransaccionesIa, DetailTransaccionesIa } from 'pages/manager/servicios-ia/creditos/transacciones';
import { ConsumoIa } from 'pages/manager/servicios-ia/operaciones/consumo';
import { EstadisticasDiarioIa } from 'pages/manager/servicios-ia/estadisticas/diario';
import { EstadisticasMensualIa } from 'pages/manager/servicios-ia/estadisticas/mensual';
import { PlantillaTurnos } from '../pages/programador-inteligente/plantilla-turnos';
import { ConfiguracionPlantillaResenas } from '../pages/calificaciones/configuracion';
import { ReglasProgramacionPorCargo } from '../pages/programador-inteligente/reglas-programacion-por-cargo';
import { ReglasGlobales } from '../pages/programador-inteligente/reglas-globales';
import { AusenciaEmpleado } from '../pages/talento-humano/ausencia-empleado';
import { RequeriminetoPersonal } from '../pages/programador-inteligente/requerimiento-personal';
import { GeneradorTurnos } from '../pages/programador-inteligente/generador-turnos';
import { CreateNovedadesRelease, DetailNovedadesRelease, EditNovedadesRelease, NovedadesRelease } from 'pages/manager/novedades';

import { PlanesIa, CreatePlanes, DetailPlanes, EditPlanes } from '../pages/manager/servicios-ia/comercial/planes';

import { Agentes, CreateAgentes, EditAgentes, DetailAgentes } from '../pages/inteligencia-artificial/agentes';
import { Asistentes, CreateAsistentes, EditAsistentes, DetailAsistentes } from '../pages/inteligencia-artificial/asistentes';
import { BaseConocimiento, CreateBaseConocimiento, EditBaseConocimiento, DetailBaseConocimiento } from '../pages/inteligencia-artificial/base-conocimiento';
import { Conversaciones } from '../pages/inteligencia-artificial/conversaciones';
import { Historial } from '../pages/inteligencia-artificial/historial';
import { CreateRequerimientoPersonal } from 'pages/programador-inteligente/requerimiento-personal/CreateRequerimientoPersonal';
import DetailRequerimientoPersonal from 'pages/programador-inteligente/requerimiento-personal/DetailRequerimientoPersonal';
import { Contratos, CrearContrato, DetailContrato, EditContrato } from 'pages/talento-humano/contratos';



export const PrivateRoutes = () => {

  const location = useLocation();

  return (
    <Routes>
      <Route path="/" element={<Main />} >

        {/* MANAGER  */}
        <Route path="/manager/clientes" element={<Customer />} />
        <Route path="/manager/crear-cliente" element={<CreateCustomer />} />
        <Route path="/manager/clientes/:id/detalle" element={<DetailCustomer />} />
        <Route path="/manager/clientes/:id/editar" element={<EditCustomer />} />
        {/* MANAGER NOVEDADES  */}
         <Route path="/manager/novedades" element={<NovedadesRelease />} />
         <Route path="/manager/novedades/crear" element={<CreateNovedadesRelease />} />
         <Route path="/manager/novedades/:id/detalle" element={<DetailNovedadesRelease />} />
         <Route path="/manager/novedades/:id/editar" element={<EditNovedadesRelease />} />
        {/* MANAGER PERMISOS  */}
        <Route path="/manager/permisos" element={<Permissions />} />
        <Route path="/manager/permisos/crear" element={<CreatePermissions />} />
        <Route path="/manager/permisos/:id/detalle" element={<DetailPermissions />} />
        <Route path="/manager/permisos/:id/editar" element={<EditPermissions />} />

        {/* AJUSTES GLOBAL IA */}
        <Route path="/manager/plataforma-ia/configuracion/ajustes" element={<AjustesGlobalesIa />} />
        <Route path="/manager/plataforma-ia/configuracion/ajustes/crear" element={<CreateAjustesGlobalesIa />} />
        <Route path="/manager/plataforma-ia/configuracion/ajustes/:id/detalle" element={<DetailAjustesGlobalesIa />} />
        <Route path="/manager/plataforma-ia/configuracion/ajustes/:id/editar" element={<EditAjustesGlobalesIa />} />
        {/* SERVICIOS IA */}
        <Route path="/manager/plataforma-ia/configuracion/servicios" element={<ServiciosIa />} />
        <Route path="/manager/plataforma-ia/configuracion/servicios/crear" element={<CreateServiciosIa />} />
        <Route path="/manager/plataforma-ia/configuracion/servicios/:id/detalle" element={<DetailServiciosIa />} />
        <Route path="/manager/plataforma-ia/configuracion/servicios/:id/editar" element={<EditServiciosIa />} />
        
        {/* CONFIGURACION IA */}
        <Route path="/manager/plataforma-ia/comercial/planes" element={<PlanesIa />} />
        {/* INTELIGENCIA ARTIFICIAL BALANCES  */} 
        <Route path="/manager/plataforma-ia/creditos/balance" element={<BalanceIa />} />
        <Route path="/manager/plataforma-ia/creditos/balance/:id/detalle" element={<DetailBalanceIa />} />
        {/* INTELIGENCIA ARTIFICIAL TRANSACCIONES */}
        <Route path="/manager/plataforma-ia/creditos/transacciones" element={<TransaccionesIa />} />
        <Route path="/manager/plataforma-ia/creditos/transacciones/:id/detalle" element={<DetailTransaccionesIa />} />
        <Route path="/manager/plataforma-ia/operaciones/consumo" element={<ConsumoIa />} />
       
       <Route path="/manager/plataforma-ia/estadisticas/diario" element={<EstadisticasDiarioIa />} />
       <Route path="/manager/plataforma-ia/estadisticas/mensual" element={<EstadisticasMensualIa />} />
  
        {/* USUARIOS PERMISOS  */}
        <Route path="/manager/usuarios-permisos" element={<UsuariosPermisos />} />
        <Route path="/manager/usuarios-permisos/detalle" element={<DetailUsuarioPermissions />} />
        <Route path="/manager/usuarios-permisos/editar" element={<EditUserPermissions />} />


        {/* COMPAÃ‘IA  */}
        <Route path="/configuracion/compania" element={<Compania />} />
        <Route path="/configuracion/crear-compania" element={<CrearEmpresa />} />
        <Route path="/configuracion/compania/detalle-compania" element={<DetalleCompania />} />
        <Route path="/configuracion/compania/editar-compania" element={<EditarCompania />} />


        {/* AREAS  */}
        <Route path="/configuracion/areas" element={<Areas />} />


        {/* CARGOS  */}
        <Route path="/configuracion/cargos" element={<Cargos />} />



        {/* USUARIO PERMISOS  */}
        <Route path="/configuracion/usuarios-permisos" element={<UsuariosPermisos />} />


        {/* LOGS  */}
        <Route path="/configuracion/logs" element={<LogAcciones />} />


        {/* CAMPOS ORDENES SERVICIOS  */}
        <Route path="/configuracion/ordenes-servicio/campos" element={<CamposOrdenesServicio />} />


        {/* ASIGNAR ORDENES SERVICIO  */}
        <Route path="/configuracion/ordenes-servicio/asignar-campos" element={<AsignarCamposOrdenesServicio />} />


        {/* ORDENES SERVICIO  */}
        <Route path="/ordenes-servicio" element={<OrdenesServicio />} />


        {/* CREAR ORDENES SERVICIO  */}
        <Route path="/ordenes-servicio/nueva" element={<CrearOrdenDeServicio />} />


        {/* COTIZACIONES  */}
        <Route path="/ordenes-servicio/cotizaciones" element={<Cotizaciones />} />


        {/* NUEVA COTIZACIONES  */}
        <Route path="/ordenes-servicio/cotizaciones/nueva" element={<CrearCotizacion />} />


        {/* EMPLEADOS  */}
        <Route path="/talento-humano/empleados" element={<Employees />} />
        <Route path="/talento-humano/crear-empleado" element={<CreateEmployee />} />
        <Route path="/talento-humano/empleados/:id/detalle" element={<DetailEmployee />} />
        <Route path="/talento-humano/empleados/:id/editar" element={<EditEmployee />} />
 
        {/* CONTRATOS  */}
        <Route path="/talento-humano/contratos" element={<Contratos />} />
        <Route path="/talento-humano/contratos/crear" element={<CrearContrato />} />
        <Route path="/talento-humano/contratos/:id/detalle" element={<DetailContrato />} />
        <Route path="/talento-humano/contratos/:id/editar" element={<EditContrato />} />

        {/* TURNOS  */}
        <Route path="/talento-humano/turnos" element={<Turnos />} />
        <Route path="/talento-humano/generar-por-configuracion" element={<GenerarPorConfiguracion />} />

        {/* AUSENCIAS EMPLEADO */}
        <Route path="/talento-humano/empleado-ausencias" element={<AusenciaEmpleado />} />


        {/* TURNOS EMPLEADOS  */}
        <Route path="/talento-humano/turnos-empleados" element={<TurnosEmpleados />} />





        {/* CONTROL TIEMPOS  */}
        <Route path="/talento-humano/control-tiempos" element={<ControlTiempos />} />




        {/* PARAMETROS  */}
        <Route path="/talento-humano/parametros" element={<Parametros />} />


        {/* GESTION FINANCIERA  */}
        <Route path="/talento-humano/gestion-financiera" element={<GestionFinanciera />} />


        {/* GESTION FINANCIERA EMPLEADO */}
        <Route path="/talento-humano/gestion-financiera-empleado" element={<GestionFinancieraEmpleado />} />


        {/* TIPO NOVEDADES  */}
        <Route path="/talento-humano/tipo-novedades" element={<TipoNovedades />} />

        {/* NOVEDADES TURNOS  */}
        <Route path="/talento-humano/novedades-turnos" element={<NovedadesTurnos />} />



        <Route path="/configuracion/sucursales" element={<Sucursal />} />
        <Route path="/configuracion/crear-sucursal" element={<CrearSucursalEmpresa />} />
        <Route path="/configuracion/sucursal/detalle-sucursal" element={<DetalleSucursal />} />
        <Route path="/configuracion/sucursal/editar-sucursal" element={<EditarSucursal />} />


        {/* EMPLOYEE TERMINALS  */}
        <Route path="/configuracion/terminales-entrada-salida" element={<TerminalEmpleados />} />
        <Route path="/configuracion/terminales-descanso" element={<TerminalDescansos />} />




        {/* HOTEL  */}
        <Route path="/hotel/codigos-express-checkin" element={<CodigosExpressCheckin />} />
        <Route path="/hotel/registros-express-checkin" element={<RegistrosExpressCheckin />} />


        {/* CALIFICACIONES */}
        <Route path="/calificaciones/gestion-dispositivos" element={<GestionDispositivos />} />
        <Route path="/calificaciones/configurar-encuestas" element={<ConfiguracionEncuestas />} />
        <Route path="/calificaciones/asignar-encuestas" element={<AsignarEncuestas />} />
        <Route path="/calificaciones/gestion-calificaciones" element={<GestionCalificaciones />} />


        {/* HALLAZGOS AUTOMATICOS */}
        <Route path="/calificaciones/hallazgos-automaticos" element={<HallazgosAutomaticos />} />
        <Route path="/calificaciones/reglas-y-alertas" element={<ReglasyAlertas />} />
        <Route path="/calificaciones/resumen" element={<Resumen />} />
        <Route path="/calificaciones/sla" element={<Sla />} />
        <Route path="/calificaciones/gestion-areas" element={<AreasCalificaciones />} />
        <Route path="/calificacion/reputacion-online/resumen" element={<ResumenReputacion />} />
        <Route path="/calificacion/reputacion-online/resenas" element={<Resenas />} />
        <Route path="/calificacion/reputacion-online/referidos-comerciales" element={<ReferidosComerciales />} />
        <Route path="/calificacion/reputacion-online/plantillas-respuestas" element={<PlantillasRespuestas />} />
        <Route path="/calificacion/reputacion-online/estadisticas" element={<Estadisticas />} />
        <Route path="/calificacion/reputacion-online/configuracion" element={<Configuracion />} />
        <Route path="/calificaciones/link-encuestas" element={<LinksEncuestasPage />} />
        <Route path="/calificaciones/configuracion" element={<ConfiguracionPlantillaResenas />} />


        {/* PERFIL */}
        <Route path="/perfil" element={<Perfil />} />



        {/* REPORTES  */}
        <Route path="/talento-humano/reporte-control-tiempos" element={<ReporteControlTiempos />} />



        {/* PROGRAMADOR INTELIGENTE  */}
        <Route path="/talento-humano/programador/plantillas" element={<PlantillaTurnos />} />
        <Route path="/talento-humano/programador/reglas-por-cargo" element={<ReglasProgramacionPorCargo />} />
        <Route path="/talento-humano/programador/reglas-globales" element={<ReglasGlobales />} />
        <Route path="/talento-humano/programador/requerimiento-de-personal" element={<RequeriminetoPersonal />} />
        <Route path="/talento-humano/programador/requerimiento-de-personal/crear" element={<CreateRequerimientoPersonal />} />
        <Route path="/talento-humano/programador/requerimiento-de-personal/:id/editar" element={<DetailRequerimientoPersonal />} />
        <Route path="/talento-humano/programador/generador" element={<GeneradorTurnos />} />
        
        {/* INTELIGENCIA ARTIFICIAL */}
        <Route path="/inteligencia-artificial/asistentes" element={<Asistentes />} />
        <Route path="/manager/plataforma-ia/agentes" element={<Agentes />} />
        <Route path="/manager/plataforma-ia/agentes/crear" element={<CreateAgentes />} />
        <Route path="/manager/plataforma-ia/agentes/:id/detalle" element={<DetailAgentes />} />
        <Route path="/manager/plataforma-ia/agentes/:id/editar" element={<EditAgentes />} />
         {/* INTELIGENCIA ASISTENTES */}
        <Route path="/manager/plataforma-ia/asistentes" element={<Asistentes />} />
        <Route path="/manager/plataforma-ia/asistentes/crear" element={<CreateAsistentes />} />
        <Route path="/manager/plataforma-ia/asistentes/:id/detalle" element={<DetailAsistentes />} />
        <Route path="/manager/plataforma-ia/asistentes/:id/editar" element={<EditAsistentes />} />
         {/* INTELIGENCIA ARTIFICIAL PLANES*/}
        <Route path="/manager/plataforma-ia/comercial/planes" element={<PlanesIa />} />
        <Route path="/manager/plataforma-ia/comercial/planes/crear" element={<CreatePlanes />} />
        <Route path="/manager/plataforma-ia/comercial/planes/:id/detalle" element={<DetailPlanes />} />
        <Route path="/manager/plataforma-ia/comercial/planes/:id/editar" element={<EditPlanes />} />
        <Route path="/manager/plataforma-ia/comercial/suscripciones" element={<SuscripcionesIa />} />
        {/* INTELIGENCIA ARTIFICIAL SUSCRIPCIONES*/}
        <Route path="/manager/plataforma-ia/comercial/suscripciones/crear" element={<CreateSuscripciones />} />
        <Route path="/manager/plataforma-ia/comercial/suscripciones/:id/detalle" element={<DetailSuscripciones />} />
        <Route path="/manager/plataforma-ia/comercial/suscripciones/:id/editar" element={<EditSuscripciones />} />
        {/* INTELIGENCIA ARTIFICIAL BALANCES */}
        <Route path="/manager/plataforma-ia/creditos/balances" element={<BalanceIa />} />
        <Route path="/manager/plataforma-ia/creditos/balances/:id/detalle" element={<DetailBalanceIa />} />
        <Route path="/inteligencia-artificial/base-conocimiento" element={<BaseConocimiento />} />
        <Route path="/inteligencia-artificial/base-conocimiento/crear" element={<CreateBaseConocimiento />} />
        <Route path="/inteligencia-artificial/base-conocimiento/editar/:id" element={<EditBaseConocimiento />} />
        <Route path="/inteligencia-artificial/base-conocimiento/detalle/:id" element={<DetailBaseConocimiento />} />
        <Route path="/inteligencia-artificial/conversaciones" element={<Conversaciones />} />
        <Route path="/inteligencia-artificial/historial" element={<Historial />} />


        <Route path="*" element={<Navigate to={'/'} replace />} />
      </Route>
    </Routes>
  )
}